import "./App.css";
import React, { useEffect, lazy, Suspense } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Routes, Route } from "react-router-dom";
import LayoutPage from "./Components/LayoutPage";
import NotFound from "./Pages/NotFound";

// Organized lazy-loaded components by category
const Home = lazy(() => import("./Pages/Home"));
const Work = lazy(() => import("./Pages/Work"));
const Resources = lazy(() => import("./Pages/Resources"));
const Contactus = lazy(() => import("./Pages/Contactus"));
const Gallery = lazy(() => import("./Pages/Gallery"));

// About Us
const OurStory = lazy(() => import("./Pages/Aboutus/OurStory"));
const Careers = lazy(() => import("./Pages/Aboutus/Careers"));
const LifeAtAlphai = lazy(() => import("./Pages/Aboutus/LifeAtAlphai"));
const EngagementModels = lazy(() => import("./Pages/Aboutus/EngagementModels"));

// Who We Serve
const StartUps = lazy(() => import("./Pages/WeWeServe/Types/StartUps"));
const Scaleups = lazy(() => import("./Pages/WeWeServe/Types/Scaleups"));
const Enterprises = lazy(() => import("./Pages/WeWeServe/Types/Enterprises"));
const ITFirms = lazy(() => import("./Pages/WeWeServe/Types/ITFirms"));

// Industries
const BankingFinance = lazy(() => import("./Pages/WeWeServe/Industries/BankingFinance"));
const FoodBeverages = lazy(() => import("./Pages/WeWeServe/Industries/FoodBeverages"));
const RetailCommerce = lazy(() => import("./Pages/WeWeServe/Industries/RetailCommerce"));
const Education = lazy(() => import("./Pages/WeWeServe/Education"));
const Healthcare = lazy(() => import("./Pages/WeWeServe/Healthcare"));
const Sports = lazy(() => import("./Pages/WeWeServe/Sports"));
const SocialNetworking = lazy(() => import("./Pages/WeWeServe/SocialNetworking"));
const SupplyChain = lazy(() => import("./Pages/WeWeServe/SupplyChain"));
const TravelHospitality = lazy(() => import("./Pages/WeWeServe/TravelHospitality"));

// Product Engineering
const ProductEngineering = lazy(() => import("./Pages/WhatWeDo/Product Engineering/ProductEngineering"));
const Discovery = lazy(() => import("./Pages/WhatWeDo/Product Engineering/Discovery"));
const UXUIDesign = lazy(() => import("./Pages/WhatWeDo/Product Engineering/UXUIDesign"));
const ChatGPTIntegration = lazy(() => import("./Pages/WhatWeDo/Product Engineering/ChatGPTIntegration"));
const DigitalTransformation = lazy(() => import("./Pages/WhatWeDo/Product Engineering/DigitalTransformation"));
const ProductDevelopment = lazy(() => import("./Pages/WhatWeDo/Product Engineering/ProductDevelopment"));

// Web Development
const Web = lazy(() => import("./Pages/WhatWeDo/Web Development/Web"));
const Angular = lazy(() => import("./Pages/WhatWeDo/Web Development/Angular"));
const DotNet = lazy(() => import("./Pages/WhatWeDo/Web Development/DotNet"));
const Java = lazy(() => import("./Pages/WhatWeDo/Web Development/Java"));
const Node = lazy(() => import("./Pages/WhatWeDo/Web Development/Node"));
const Php = lazy(() => import("./Pages/WhatWeDo/Web Development/Php"));
const Python = lazy(() => import("./Pages/WhatWeDo/Web Development/Python"));
const Reactjs = lazy(() => import("./Pages/WhatWeDo/Web Development/Reactjs"));
const Vue = lazy(() => import("./Pages/WhatWeDo/Web Development/Vue"));
const Bootstrap = lazy(() => import("./Pages/WhatWeDo/Web Development/Bootstrap"));
const JavaScript = lazy(() => import("./Pages/WhatWeDo/Web Development/JavaScript"));
const HtmlCss = lazy(() => import("./Pages/WhatWeDo/Web Development/HtmlCss"));
const Gatsby = lazy(() => import("./Pages/WhatWeDo/Web Development/Gatsby"));
const FontEnd = lazy(() => import("./Pages/WhatWeDo/Web Development/FontEnd"));
const BackEnd = lazy(() => import("./Pages/WhatWeDo/Web Development/BackEnd"));

// Mobile Development
const MobileDevelopment = lazy(() => import("./Pages/WhatWeDo/Mobile Development/MobileDevelopment"));
const AndroidAppDev = lazy(() => import("./Pages/WhatWeDo/Mobile Development/AndroidAppDev"));
const Flutter = lazy(() => import("./Pages/WhatWeDo/Mobile Development/Flutter"));
const ReactNative = lazy(() => import("./Pages/WhatWeDo/Mobile Development/ReactNative"));
const IOSApp = lazy(() => import("./Pages/WhatWeDo/Mobile Development/IOSApp"));

// QA & Management
const QAManagement = lazy(() => import("./Pages/WhatWeDo/QA & Management/QAManagement"));
const QualityAssurance = lazy(() => import("./Pages/WhatWeDo/QA & Management/QualityAssurance"));
const AppSupport = lazy(() => import("./Pages/WhatWeDo/QA & Management/AppSupport"));
const ProductManagement = lazy(() => import("./Pages/WhatWeDo/QA & Management/ProductManagement"));
const ProjectManagement = lazy(() => import("./Pages/WhatWeDo/QA & Management/ProjectManagement"));
const AppModernization = lazy(() => import("./Pages/WhatWeDo/QA & Management/AppModernization"));

// Talent Solution
const TalentSolution = lazy(() => import("./Pages/WhatWeDo/Talent Solution/TalentSolution"));
const BuildYourTeam = lazy(() => import("./Pages/WhatWeDo/Talent Solution/BuildYourTeam"));
const HireDeveloper = lazy(() => import("./Pages/WhatWeDo/Talent Solution/HireDeveloper"));

// DevOps
const DevOps = lazy(() => import("./Pages/WhatWeDo/DevOps Solutions/DevOps"));
const CICD = lazy(() => import("./Pages/WhatWeDo/DevOps Solutions/CICD"));
const CloudEng = lazy(() => import("./Pages/WhatWeDo/DevOps Solutions/CloudEng"));
const Consulting = lazy(() => import("./Pages/WhatWeDo/DevOps Solutions/Consulting"));

// Digital Marketing
const DigitalMarketing = lazy(() => import("./Pages/Xmedia/Digital Marketing/DigitalMarketing"));
const ContentMarketing = lazy(() => import("./Pages/Xmedia/Digital Marketing/ContentMarketing"));
const EmailMarketing = lazy(() => import("./Pages/Xmedia/Digital Marketing/EmailMarketing"));
const Sco = lazy(() => import("./Pages/Xmedia/Digital Marketing/Seo"));

// Brand Activation
const BrandActivation = lazy(() => import("./Pages/Xmedia/Brand Activation/BrandActivation"));
const BrandStrategy = lazy(() => import("./Pages/Xmedia/Brand Activation/BrandStrategy"));
const Digitalcampaigns = lazy(() => import("./Pages/Xmedia/Brand Activation/Digitalcampaigns"));
const Influencercollaboration = lazy(() => import("./Pages/Xmedia/Brand Activation/Influencercollaboration"));

// Develop
const Develop = lazy(() => import("./Pages/Xmedia/Develop/Develop"));
const MobileAppDevelopment = lazy(() => import("./Pages/Xmedia/Develop/MobileAppDevelopment"));
const WebsiteDevelopment = lazy(() => import("./Pages/Xmedia/Develop/WebsiteDevelopment"));

// Design
const Design = lazy(() => import("./Pages/Xmedia/Design/Design"));
const Animations = lazy(() => import("./Pages/Xmedia/Design/Animations"));
const GraphicDesign = lazy(() => import("./Pages/Xmedia/Design/GraphicDesign"));
const WebDesign = lazy(() => import("./Pages/Xmedia/Design/WebDesign"));
const UiuxDesign = lazy(() => import("./Pages/Xmedia/Design/UiuxDesign"));

// Trending Tech
const AIIntegration = lazy(() => import("./Pages/Capabilities/TrendingTech/AIIntegration"));
const BigData = lazy(() => import("./Pages/Capabilities/TrendingTech/BigData"));
const Blockchain = lazy(() => import("./Pages/Capabilities/TrendingTech/Blockchain"));

// Cloud
const Aws = lazy(() => import("./Pages/Capabilities/Cloud/Aws"));
const Azure = lazy(() => import("./Pages/Capabilities/Cloud/Azure"));
const Cloud = lazy(() => import("./Pages/Capabilities/Cloud/Cloud"));
const GCP = lazy(() => import("./Pages/Capabilities/Cloud/GCP"));

// CMS
const JAMStack = lazy(() => import("./Pages/Capabilities/CMS/JAMStack"));
const WooCommerce = lazy(() => import("./Pages/Capabilities/CMS/WooCommerce"));
const WordPress = lazy(() => import("./Pages/Capabilities/CMS/WordPress"));
const Cms = lazy(() => import("./Pages/Capabilities/CMS/Cms"));

// Database
const Database = lazy(() => import("./Pages/Capabilities/Database/Database"));
const FIreStore = lazy(() => import("./Pages/Capabilities/Database/FIreStore"));
const MongoDB = lazy(() => import("./Pages/Capabilities/Database/MongoDB"));
const MySQL = lazy(() => import("./Pages/Capabilities/Database/MySQL"));
const PostgreSQL = lazy(() => import("./Pages/Capabilities/Database/PostgreSQL"));
const SQLServer = lazy(() => import("./Pages/Capabilities/Database/SQLServer"));
const Consultant = lazy(() => import("./Pages/concentrating/Consultant"));


function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route element={<LayoutPage/>}>
          {/* Main Pages */}
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/resource" element={<Resources />} />
          <Route path="/contactus" element={<Contactus />} />
          <Route path="/gallery" element={<Gallery />} />

          {/* About Us */}
          <Route path="/about/our-story" element={<OurStory />} />
          <Route path="/about/careers" element={<Careers />} />
          <Route path="/about/life-at-alphai" element={<LifeAtAlphai />} />
          <Route path="/about/engagement-models" element={<EngagementModels />} />

          {/* Who We Serve */}
          <Route path="/who-we-serve/startups" element={<StartUps />} />
          <Route path="/who-we-serve/scale-ups" element={<Scaleups />} />
          <Route path="/who-we-serve/enterprises" element={<Enterprises />} />
          <Route path="/who-we-serve/it-firms" element={<ITFirms />} />

          {/* Industries */}
          <Route path="/industries/banking-finance" element={<BankingFinance />} />
          <Route path="/industries/food-beverages" element={<FoodBeverages />} />
          <Route path="/industries/retail-commerce" element={<RetailCommerce />} />
          <Route path="/industries/education" element={<Education />} />
          <Route path="/industries/healthcare" element={<Healthcare />} />
          <Route path="/industries/sports" element={<Sports />} />
          <Route path="/industries/social-networking" element={<SocialNetworking />} />
          <Route path="/industries/supply-chain-logistics" element={<SupplyChain />} />
          <Route path="/industries/travel-hospitality" element={<TravelHospitality />} />

          {/* Product Engineering */}
          <Route path="/services/product-engineering/" element={<ProductEngineering />} />
          <Route path="/services/product-engineering/discovery" element={<Discovery />} />
          <Route path="/services/product-engineering/ux-ui" element={<UXUIDesign />} />
          <Route path="/services/product-engineering/chatgpt-integration" element={<ChatGPTIntegration />} />
          <Route path="/services/product-engineering/digital-transformation" element={<DigitalTransformation />} />
          <Route path="/services/product-engineering/product-development" element={<ProductDevelopment />} />

          {/* Web Development */}
          <Route path="/services/website-development/" element={<Web />} />
          <Route path="/services/website-development/angular" element={<Angular />} />
          <Route path="/capabilities/frontend/angular" element={<Angular />} />
          <Route path="/services/website-development/react" element={<Reactjs />} />
          <Route path="/capabilities/frontend/react" element={<Reactjs />} />
          <Route path="/services/website-development/vue" element={<Vue />} />
          <Route path="/capabilities/frontend/vuejs" element={<Vue />} />
          <Route path="/services/website-development/node" element={<Node />} />
          <Route path="/capabilities/backend/nodejs" element={<Node />} />
          <Route path="/services/website-development/python" element={<Python />} />
          <Route path="/capabilities/backend/python" element={<Python />} />
          <Route path="/services/website-development/java" element={<Java />} />
          <Route path="/capabilities/backend/java" element={<Java />} />
          <Route path="/services/website-development/dotnet" element={<DotNet />} />
          <Route path="/capabilities/backend/net" element={<DotNet />} />
          <Route path="/capabilities/frontend/bootstrap" element={<Bootstrap />} />
          <Route path="/capabilities/frontend/javascript" element={<JavaScript />} />
          <Route path="/capabilities/frontend/html-css" element={<HtmlCss />} />
          <Route path="/capabilities/frontend/gatsbyjs" element={<Gatsby />} />
          <Route path="/frontend-development/" element={<FontEnd />} />
          <Route path="/backend-development/" element={<BackEnd />} />

          {/* Mobile Development */}
          <Route path="/services/mobile-app-development/" element={<MobileDevelopment />} />
          <Route path="/services/mobile-app-development/android" element={<AndroidAppDev />} />
          <Route path="/services/mobile-app-development/flutter" element={<Flutter />} />
          <Route path="/services/mobile-app-development/ios" element={<IOSApp />} />
          <Route path="/services/mobile-app-development/react-native" element={<ReactNative />} />

          {/* QA & Management */}
          <Route path="/services/quality-assurance-management/" element={<QAManagement />} />
          <Route path="/services/quality-assurance" element={<QualityAssurance />} />
          <Route path="/services/product-management" element={<ProductManagement />} />
          <Route path="/services/app-support-maintenance" element={<AppSupport />} />
          <Route path="/services/app-modernization" element={<AppModernization />} />
          <Route path="/services/project-management" element={<ProjectManagement />} />

          {/* Talent Solution */}
          <Route path="/talent-solution/" element={<TalentSolution />} />
          <Route path="/talent-solution/our-team" element={<BuildYourTeam />} />
          <Route path="/talent-solution/hire-developer" element={<HireDeveloper />} />

          {/* Trending Tech */}
          <Route path="/capabilities/trending/ai-integration" element={<AIIntegration />} />
          <Route path="/capabilities/trending/big-data" element={<BigData />} />
          <Route path="/capabilities/trending/blockchain" element={<Blockchain />} />

          {/* DevOps */}
          <Route path="/services/devops" element={<DevOps />} />
          <Route path="/services/devops-ci-cd" element={<CICD />} />
          <Route path="/services/devops-cloud" element={<CloudEng />} />
          <Route path="/services/devops-consulting" element={<Consulting />} />

          {/* Digital Marketing */}
          <Route path="/digital-marketing/" element={<DigitalMarketing />} />
          <Route path="/digital-marketing/content" element={<ContentMarketing />} />
          <Route path="/digital-marketing/email" element={<EmailMarketing />} />
          <Route path="/digital-marketing/seo" element={<Sco />} />

          {/* Brand Activation */}
          <Route path="/brand-activation/" element={<BrandActivation />} />
          <Route path="/brand-strategy" element={<BrandStrategy />} />
          <Route path="/digital-campaigns" element={<Digitalcampaigns />} />
          <Route path="/influencer-collaboration" element={<Influencercollaboration />} />

          {/* Develop */}
          <Route path="/development/" element={<Develop />} />
          <Route path="/mobile-apps-development" element={<MobileAppDevelopment />} />
          <Route path="/website-development" element={<WebsiteDevelopment />} />

          {/* Design */}
          <Route path="/design/" element={<Design />} />
          <Route path="/design/animations" element={<Animations />} />
          <Route path="/design/graphic" element={<GraphicDesign />} />
          <Route path="/design/web" element={<WebDesign />} />
          <Route path="/design/ui-ux" element={<UiuxDesign />} />

          {/* Cloud */}
          <Route path="/capabilities/cloud/aws" element={<Aws />} />
          <Route path="/capabilities/cloud/azure" element={<Azure />} />
          <Route path="/capabilities/cloud/gcp" element={<GCP />} />
          <Route path="/cloud-services/" element={<Cloud />} />

          {/* CMS */}
          <Route path="/capabilities/cms/wordpress" element={<WordPress />} />
          <Route path="/capabilities/cms/jamstack" element={<JAMStack />} />
          <Route path="/capabilities/cms/woocommerce" element={<WooCommerce />} />
          <Route path="/cms-development/" element={<Cms />} />

          {/* Database */}
          <Route path="/database-development" element={<Database />} />
          <Route path="/capabilities/database/firestore" element={<FIreStore />} />
          <Route path="/capabilities/database/mongodb" element={<MongoDB />} />
          <Route path="/capabilities/database/mysql" element={<MySQL />} />
          <Route path="/capabilities/database/postgresql" element={<PostgreSQL />} />
          <Route path="/capabilities/database/sql-server" element={<SQLServer />} />

          <Route path="/consultancy" element={<Consultant />} />
        </Route>
        
        {/* 404 Route */}
        <Route path="*" element={<NotFound/>} />
      </Routes>
    </Suspense>
  );
}

export default App;